import React from 'react';
import DocumentTitle from 'react-document-title';
import CountDown from './CountDown';
import AXIOS from '../../api/axios';
import { COURSE_URL } from '../../constants';
import './style.less';
import { parseQuery } from '../../utils/tools';
import clientApi from '../../api/client';

const AWARD_STATUS = [null, null, null, '，实物奖励待发货', '，实物奖励已发货'];
const queryObj = parseQuery(window.location.search.slice(1));
export default class DailyAttendance extends React.PureComponent {
    state = {
        status: -1, // 打卡按钮状态-1->初始态,0->未开始,1->已开始,2->已结束
        awardRules: [],
        awardsList: [],
        activityUserInfo: {},
        activityInfo: {},
        clockDesc: null,
        showTanAward: false, // 是否显示奖品弹框
        showTanAddress: false, // 是否添加地址弹框
        isComplete: false, // 是否完成所有打卡
        beginDate: null,
        willGetAward: {},
        awardName: null,
        awardDesc: null,
        awardBigImg: null,
        threshold: null,
        progress: 0,
    }
    scrollTop = 0;
    componentDidMount() {
        this.getActivityData();
        this.getAwardDetail();
        clientApi.backRequired({ backRequired: false });
    }
    // 获取到课打卡活动信息
    getActivityData = () => {
        return AXIOS.getDailyAttendanceContent({
            data: { activityId: queryObj.activityid, stuId: queryObj.stuid }
        }, (data) => {
            const { activityInfo = {}, activityUserInfo = {} } = data || {};
            const { awardRules = [], status, beginTime, clockDesc = '' } = activityInfo;
            let progress = 0;
            let isComplete = false;
            let willGetAward = {};
            const awardRulesCount = awardRules.length;
            if (awardRulesCount > 0) {
                const willList = awardRules.filter(item => item.threshold > activityUserInfo.threshold);
                if (willList.length > 0) {
                    const { threshold, awardName } = willList[0];
                    willGetAward = {
                        name: awardName,
                        time: threshold - activityUserInfo.threshold,
                    }
                } else {
                    isComplete = true;
                }
            }
            if (awardRulesCount > 1) {
                progress = awardRules.reduce((t, item, index) => activityUserInfo.threshold >= item.threshold ? index : t, 0) / (awardRules.length - 1);
            }
            let beginDate = new Date(beginTime || new Date().getTime());
            const currDate = new Date();
            const dateDiff = Math.ceil((beginDate - currDate) / 1000 / 3600 / 24);
            if (dateDiff > 0 && dateDiff <= 2) {
                beginDate = dateDiff > 1 ? '后天' : '明天';
            } else {
                beginDate = `${beginDate.getMonth() + 1}月${beginDate.getDate()}日`
            }
            this.setState({
                activityInfo,
                awardRules,
                activityUserInfo,
                status,
                isComplete,
                beginDate,
                progress,
                willGetAward,
                clockDesc: clockDesc.split(/\s/).map((item, index) => <p className="clock-desc" key={item}>{index + 1}.{item}</p>)
            });
        });
    }
    // 获取用户到课奖励流水
    getAwardDetail = () => {
        return AXIOS.getDailyAttendanceDetail({
            data: { stuId: queryObj.stuid}
        }, (res) => {
            res = res || [];
            const needAddress = [];
            const awardsList = res.map(item => {
                const awardDate = new Date(item.awardDate || new Date().getTime());
                const month = awardDate.getMonth() + 1;
                const date = awardDate.getDate();
                item.date = `${month >= 10 ? month : '0' + month}-${date}`;
                item.isNeedAddress === 1 && needAddress.push(item);
                return item;
            });
            // 一进入页面，如果有未填写地址的奖品，弹框提示添加地址
            if (needAddress.length > 0) {
                const { awardName, bigAwardPic, threshold } = needAddress[0];
                this.setState({ showTanAddress: true, awardName, awardBigImg: bigAwardPic, threshold, awardsList });
                this.stopBodyScroll(true);
            } else {
                this.setState({ awardsList });
            }
        });
    }
    // 禁止蒙层下的页面滑动
    stopBodyScroll = (isFixed) => {
        const bodyEl = document.body;
        if (isFixed) {
            this.scrollTop = window.scrollY
            bodyEl.style.position = 'fixed'
            bodyEl.style.top = -this.scrollTop + 'px'
        } else {
            bodyEl.style.position = ''
            bodyEl.style.top = ''
            window.scrollTo(0, this.scrollTop) // 回到原先的top
        }
    }
    // 显示奖品大图弹框
    toShowBigAwardImg = (img, name, desc) => {
        this.setState({ showTanAward: true, awardName: name, awardBigImg: img, awardDesc: desc });
        this.stopBodyScroll(true);
    }
    /**
     * 隐藏弹框
     * @param {number} type 
     * type=1 隐藏奖品大图弹框
     * type=2 隐藏添加地址弹框
     */
    hideTan = type => {
        type === 1 && this.setState({ showTanAward: false });
        type === 2 && this.setState({ showTanAddress: false });
        this.stopBodyScroll(false);
    }
    goTo = path => {
        const { history } = this.props; 
        const { activityInfo = {} } = this.state;
        history.push({
            pathname: `${COURSE_URL}/${path}`,
            search: window.location.search,
            state: {
                source: 'daily/attendance',
                ruleImg: activityInfo.ruleDetailPic || null,
            }
        });
    }
    render() {
        const {
            status,
            activityUserInfo,
            awardRules,
            awardsList,
            activityInfo,
            showTanAward,
            showTanAddress,
            isComplete,
            progress,
            beginDate,
            willGetAward,
            awardBigImg,
            awardName,
            awardDesc,
            threshold,
            clockDesc,
        } = this.state;
        return <DocumentTitle title={activityInfo.name || ''}>
            <div className="DailyAttendancePage" style={activityInfo.bottomPic ? {background: `#B25426 url(${activityInfo.bottomPic}) top center / contain no-repeat`} : {}}>
            {(status === 1 || status === 2) && <div className="count-down-dialog">
                {status === 1 && <React.Fragment>
                    <p>距离打卡活动结束</p>
                    <CountDown endTime={activityInfo.endTime || null} />
                </React.Fragment>}
                {status === 2 && <span className="end-text">活动已结束</span>}
            </div>}
            <div className="attendance-box">
                <p className="attendance-award-title">点击图片查看奖品详情</p>
                <div className="attendance-award-intro">
                    <div className={`attendance-award-intro-box awards-${awardRules.length}`}>
                        <div className="attendance-award-box">
                            {
                                awardRules.map((item, index) => {
                                    return <div key={item.threshold} className="attendance-award">
                                        <div
                                            className="attendance-award-img"
                                            style={item.smallAwardPic ? {backgroundImage: `url(${item.smallAwardPic})`} : {}}
                                            onClick={this.toShowBigAwardImg.bind(this, item.bigAwardPic, item.awardName, item.awardDesc)}
                                        />
                                        <div className="attendance-award-time">{item.threshold}天</div>
                                        <div className="attendance-award-desc">{item.awardName}</div>
                                        <span className={`icon-attendance${activityUserInfo.threshold >= item.threshold ? ' active' : ''}`} />
                                    </div>
                                })
                            }
                        </div>
                        <div className="attendance-progress-box"><div className={`attendance-progress`} style={{width: `${progress * 100}%`}}></div></div>
                    </div>
                </div>
            </div>
            {(status === 0 || status === 1) && activityInfo.beginTime ? <div className="attendance-btn-box">
                {status === 0 && <React.Fragment>
                    <p className="mt28 font36">打卡将于 <em className="color1 font48">{beginDate}</em> 开始</p>
                </React.Fragment>}
                {status === 1 && !isComplete && <React.Fragment>
                    <p>已连续打卡 <em className="color1 font46">{activityUserInfo.threshold}</em> 天</p>
                    <p className="mt20">再打卡 <em className="color1 font38">{willGetAward.time}</em> 天 可得 <em className="color1">{willGetAward.name}</em></p>
                </React.Fragment>}
                {status === 1 && isComplete && <React.Fragment>
                    <p className="font48">太棒了！</p>
                    <p className="mt20 font36">你<em className="color1">已完成</em>全部打卡挑战</p>
                </React.Fragment>}
            </div> : null}
            {awardsList.length > 0 ? <div className="my-award-content">
                <h3 className="h3">我的奖品</h3>
                <ul className="my-award-ul">
                    {
                        awardsList.map(item => {
                            return <li key={item.id} className="my-award-li">
                                <div
                                    className="my-award-icon"
                                    style={item.smallAwardPic ? {backgroundImage: `url(${item.smallAwardPic})`} : {}}
                                    onClick={this.toShowBigAwardImg.bind(this, item.bigAwardPic, item.awardName, item.awardDesc)}
                                />
                                <div className="my-award-desc">
                                    <p className="font32">打卡第{item.threshold}天</p>
                                    <p className="mt20">获得{item.awardName}
                                        {item.isNeedAddress === 1 ?
                                            <span>，<em className="color2"  onClick={this.goTo.bind(this, 'daily/address')}>填写收货地址</em> 领取实物奖励</span>
                                            : (AWARD_STATUS[item.awardStatus] || null)}
                                    </p>
                                </div>
                                <span className="my-award-time">{item.date}</span>
                            </li>
                        })
                    }
                </ul>
            </div> : null}
            <div className="rules-content">
                <h3 className="h3">规则说明</h3>
                <div className="rules-box">
                    <div className="rules-intro">
                        {clockDesc}
                    </div>
                    <button className="btn-more" onClick={this.goTo.bind(this, 'daily/attendance/rules')}>更多规则说明</button>
                </div>
            </div>
            <div className="company-name">杭州潘哒教育科技有限公司</div>
            <div className={`tan-award-box-mask${showTanAward ? ' show' : ''}`}>
                <div className="tan-award-box">
                    <div className="tan-award-img-box">
                        <div className="tan-award-img">
                            <div style={awardBigImg ? {height: '100%', background: `url(${awardBigImg}) center center / 85% 85% no-repeat`} : {height: '100%'}}></div>
                        </div>
                    </div>
                    <p className="font44">{awardName}</p>
                    <p className="mt32 fw_normal">{awardDesc}</p>
                    <button className="btn-sure" onClick={this.hideTan.bind(this, 1)}>确定</button>
                </div>
            </div>
            <div className={`tan-address-box-mask${showTanAddress ? ' show' : ''}`}>
                <div className="tan-address-box">
                    <p>21天英语习惯养成</p>
                    <p className="mt96 font36 color4">恭喜您，已完成打卡{threshold}天</p>
                    <div className="tan-address-img" style={awardBigImg ? {background: `url(${awardBigImg}) center center / 85% 85% no-repeat`} : {}}></div>
                    <p className="font30 color3">获得{awardName}</p>
                    <button className="btn-add" onClick={this.goTo.bind(this, 'daily/address')}>填写收货地址</button>
                    <p className="mt27 color5 font22 fw_normal">请尽快填写收货地址，领取实物奖励</p>
                    <button className="btn-close" onClick={this.hideTan.bind(this, 2)} />
                </div>
            </div>
        </div>
        </DocumentTitle>
    }
}


// WEBPACK FOOTER //
// ./src/components/dailyAttendancePage/index.jsx